import {removeClientContact} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

export function removeClientContactMutationOptions(clientId: string) {
  return mutationOptions({
    mutationFn: (contactId: number) => removeClientContact(clientId, contactId),
    mutationKey: clientMutationKeys.removeClientContact,
    onSuccess: async (_result, _contactId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
